// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"79c09868","821":"8c1bc21a"}[chunkId] + ".chunk.js";
};